
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {StaffUpdateRequestType} from "@/form/staff/StaffUpdate.types";
import {fio, date} from "@/utils/validators";
import {ICategory} from "@/entity/category/category.types";
import {IWorkersListItem} from "@/entity/workers/workers.types";
import {IPosition, PositionName} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import {ICms_Category} from "@/entity/staff/staff.types";

@Component
export default class StaffUpdateForm extends Form {
    @Validate(fio, i18nText("Введите корректное ФИО"))
    fio = '';
    @Validate(required, i18nText("Выберите статус"))
    status_id: number | null = null;
    @Validate(required, i18nText("Выберите должность"))
    position_id: number | null = null;
    //@Validate(required, 'Выберите схему зп')
    salary: number | null = null;
    @Validate(required, i18nText("Введите номер телефона"))
    phone = '';
    salon_id = 0;
    @Validate(requiredIf(function (vm): boolean {
        return vm.position_id === vm.positionsList.find((el: IPosition) => el.name === vm.positionName.COSMETOLOG).id
    }), i18nText("Введите категорию"))
    cosmetolog_category_id: number | null = null;
    @Validate(date, i18nText("Введите корректную дату"))
    birth_date: any;
    @Validate(date, i18nText("Введите корректную дату"))
    employment_date: any;
    description = '';
    positionName = PositionName;
    positionsList: IPosition[] = [
        {id: null, name: i18nText("Не выбрано")}
    ]
    categoryList: ICms_Category[] = [
        {id: null, name: i18nText("Не выбрано")}
    ]
    statusList: IStatus[] = [
        {id: null, name: i18nText("Не выбрано")}
    ]
    salaryList: ISalaryScheme[] = [
        {id: null, name: i18nText("Не выбрано"), type: true}
    ]
    id = 0;
    status_data: IStatus | null = null;
    //position_id: number | null = null;
    salary_schema_id: number | null = null;
    name: string | null = null;
    last_name: string | null = null;
    middle_name: string | null = null;
    category: Record<string, any> | null = null;

    getFormData(): StaffUpdateRequestType {
        return {
            id: this.id,
            name: this.fio.split(' ')[1],
            last_name: this.fio.split(' ')[0],
            middle_name: this.fio.split(' ')[2] ? this.fio.split(' ')[2] : null,
            status_id: this.status_id,
            phone: this.phone,
            salon_id: this.salon_id,
            cosmetolog_category_id: this.cosmetolog_category_id,
            birth_date: this.birth_date,
            employment_date: this.employment_date,
            description: this.description,
            position_id: this.position_id,
            salary_schema_id: this.salary
        }
    }

    setFormData(positions: IPosition[], category: ICms_Category[], statuses: IStatus[], salary: ISalaryScheme[], worker: IWorkersListItem | null): void {
        this.positionsList = [];
        this.categoryList = [];
        this.statusList = [];
        this.salaryList = [];
        positions.forEach(el => this.positionsList.push(el));
        category.forEach(el => this.categoryList.push(el));
        statuses.forEach(el => this.statusList.push(el));
        salary.forEach(el => this.salaryList.push(el));
        if (worker !== undefined && worker != null) {
            this.id = worker.id;
            this.name = worker.name;
            this.last_name = worker.last_name;
            this.middle_name = worker.middle_name ? ' ' + worker.middle_name : '';
            this.fio = worker.last_name + ' ' + worker.name + this.middle_name;
            this.category = worker.category;
            this.salon_id = worker.salon_id;
            //this.status_data = worker.status;
            this.phone = worker.phone;
            this.cosmetolog_category_id = worker.cosmetolog_category_id;
            this.birth_date = worker.birth_date;
            this.employment_date = worker.employment_date;
            this.description = worker.description;
            this.position_id = worker.position_id;
            this.salary = worker.salary_schema_id;
            this.status_id = worker.status.id;
        }
    }
}
